import { get, post } from '@/lib/api/client'
import {
    type PressReleaseReply,
    type PressReleaseReplyCreate,
    type ApiResponse,
    PressReleaseReplyCreateSchema
} from '@/lib/api/types'

export class PressReleaseReplyService {
    /**
     * Get all replies for a comment
     * GET /press-release-replies/public/all/{commentId}
     */
    async getReplies(commentId: string): Promise<ApiResponse<PressReleaseReply[]>> {
        return await get<ApiResponse<PressReleaseReply[]>>(
            `press-release-replies/public/all/${commentId}`
        )
    }

    /**
     * Add a reply to a comment
     * POST /press-release-replies/public/addreply/{commentId}
     */
    async addReply(
        commentId: string,
        data: PressReleaseReplyCreate
    ): Promise<ApiResponse<PressReleaseReply>> {
        const validatedData = PressReleaseReplyCreateSchema.parse(data)
        return await post<ApiResponse<PressReleaseReply>>(
            `press-release-replies/public/addreply/${commentId}`,
            validatedData
        )
    }
}

// Export singleton instance
export const pressReleaseReplyService = new PressReleaseReplyService()

// Export default
export default pressReleaseReplyService
